<template>
  <div class="table-overflow">
    <table>
      <thead>
      <tr>
        <td class="td-num">№</td>
        <td>{{ $t('Вид животного') }}</td>
        <td>{{ $t('Кол-во') }}</td>
        <td>{{ $t('Серия и № отст. карты') }}</td>
        <td>{{ $t('Серия и № троф. листа') }}</td>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, i) in faunaLicenseApplicationBsoItems" :key="i">
        <td class="td-num">{{ i + 1 }}</td>
        <td>{{ item.faunaName }}</td>
        <td>{{ item.headCount }}</td>
        <td>
          <template v-if="item.shooting_card">
            <p v-for="(shootingCard, index) in item.shooting_card" :key="index">
              {{ shootingCard.strictReportingFormTypeName }} {{ shootingCard.bsoNumber }}
            </p>
          </template>
        </td>
        <td>
          <template v-if="item.trophySheet">
            <p v-for="(trophySheet, index) in item.trophySheet" :key="index">
              {{ trophySheet.strictReportingFormTypeName }} {{ trophySheet.bsoNumber }}
            </p>
          </template>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    faunaLicenseApplicationBsoItems: Array
  }
}
</script>

<style scoped>

</style>
